import { Injectable, Injector } from "@angular/core";
import {
    HttpEvent,
    HttpRequest,
    HttpHandler,
    HttpInterceptor,
    HttpErrorResponse
} from "@angular/common/http";
import { EMPTY, Observable, catchError, throwError } from "rxjs";
import { environment } from "@env/environment";
import { AuthService } from '../auth/auth.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    private token = '';
    private ocpKey = environment.ocpKey;
    constructor(
        private inj: Injector,
        private _authService: AuthService
        ) {
            this.token = this._authService.getToken()
         }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.includes("blob.core.windows.net")) {
            return next.handle(req); // No modificar esta petición
        }

        if (req.headers.has('Authorization')) {
            return next.handle(req);
        }

        const tok = this.inj.get(AuthService);

        // Con el token vencido la API no responde: se cierra la sesión sin enviar la petición
        if (tok.isTokenExpired()) {
            tok.expireSession();
            return EMPTY;
        }

        const authHeader = tok.getToken();

        if (!tok.isLoggedIn()) {
            const dupReq = req.clone({
                headers: req.headers
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .set('Ocp-Apim-Subscription-Key', this.ocpKey)
            });
            return next.handle(dupReq);
        } else {
            const dupReq = req.clone({
                headers: req.headers
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .set('Ocp-Apim-Subscription-Key', this.ocpKey)
                    .set('Authorization', `Bearer ${authHeader}`)
            });
            // La API rechazó el token (vencido o revocado): se cierra la sesión
            return next.handle(dupReq).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) tok.expireSession();
                    return throwError(() => error);
                })
            );
        }
    }
}
